import {useQuery} from 'react-query';
import { getThread } from '../api';

export const DISCUSSION_THREAD_CACHE_KEY = 'DISCUSSION_THREAD';

export const useDiscussionThread = (id: string) => {
  const keys = [DISCUSSION_THREAD_CACHE_KEY, id];

  return useQuery(keys, async () => {
    const response = await getThread(id);

    return response;
  });
};